import { Box, Flex, FlexProps, Link, ProfileAvatar, SubMenu, SubMenuItem, useModal, Text } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { getBlockExploreLink } from 'utils'
import { PredictionUser } from 'state/types'
import { useProfileForAddress } from 'state/profile/hooks'
import truncateHash from '@pancakeswap/utils/truncateHash'
import { useTranslation } from '@pancakeswap/localization'
import { useStatModalProps } from 'state/predictions/hooks'
import { useConfig } from 'views/Predictions/context/ConfigProvider'
import WalletStatsModal from '../WalletStatsModal'

interface ResultAvatarProps extends FlexProps {
  user: PredictionUser
}

const UsernameWrapper = styled(Box)`
  margin-left: 8px;
  &:hover div {
    color: #03f5ae;
  }
`

const ResultAvatar: React.FC<React.PropsWithChildren<ResultAvatarProps>> = ({ user, ...props }) => {
  const { t } = useTranslation()
  const { profile } = useProfileForAddress(user.id)
  const { result, address, leaderboardLoadingState } = useStatModalProps(user.id)
  const { token, api } = useConfig()

  const [onPresentWalletStatsModal] = useModal(
    <WalletStatsModal
      api={api}
      token={token}
      result={result}
      address={address}
      leaderboardLoadingState={leaderboardLoadingState}
    />,
    true,
    false,
    'ResultAvatarWalletStatsModal',
  )

  return (
    <SubMenu
      component={
        <Flex alignItems="center" {...props}>
          {' '}
          <img src="/images/leaderboard/avt.svg" alt="avt" width="24px" height="24px" />
          <UsernameWrapper>
            <Text color="white" fontWeight="400">
              {profile?.username || truncateHash(user.id)}
            </Text>{' '}
          </UsernameWrapper>
          {/* <AvatarWrapper
            width={['32px', null, null, null, null, '40px']}
            height={['32px', null, null, null, null, '40px']}
          >
            <ProfileAvatar src={profile?.nft?.image?.thumbnail} height={36} width={36} />
          </AvatarWrapper> */}
        </Flex>
      }
      options={{ placement: 'bottom-start' }}
    >
      <SubMenuItem onClick={onPresentWalletStatsModal}>{t('View Stats')}</SubMenuItem>
      <SubMenuItem as={Link} href={getBlockExploreLink(user.id, 'address')} bold={false} color="text" external>
        {t('View in Explorer')}
      </SubMenuItem>
    </SubMenu>
  )
}

export default ResultAvatar
